import { useActorMember, useSubjectMember } from '@healthblocks-io/core'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout/index'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { environment } from '@/config/environment'
import { useAppInfo } from '@/modules/shared/hooks/useAppInfo'
import { AppInfoContainer } from './AppInfo.styled'

const AppInfo = () => {
  const info = useAppInfo()
  const actorMember = useActorMember()
  const subjectMember = useSubjectMember()

  return (
    <AppInfoContainer>
      <FlexColumn>
        {info ? (
          <>
            <Span type='BodySmallRegular'>
              Version: {info.version} {info.build && `(${info.build})`}
            </Span>
            <Span type='BodySmallRegular'>Environment: {environment.env}</Span>
          </>
        ) : null}
        <Span type='BodySmallRegular'>Actor: {actorMember?.name}</Span>
        <Span type='BodySmallRegular'>Subject: {subjectMember?.name}</Span>
      </FlexColumn>
    </AppInfoContainer>
  )
}

export { AppInfo }
